// extracted by mini-css-extract-plugin
export default {"banner":"Header_banner__6EP0r","button":"Header_button__6PECw","fullHeight":"Header_fullHeight__x-iNh"};